import { Component,  Input } from '@angular/core';
import { Wrapper } from '../../components/wrapper.component';
import { createEmptySection, Budget, BudgetSchedule, BudgetSection, ManageBudgetLinkOption, AddItemRowData, BudgetRevenueShareBase, BudgetRevenueShare, SectionSettings } from '../../store/reselectors/budget.data';
import { OnInit } from '@angular/core';
import { JoiEvent } from 'src/app/store/events.era';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { eventDateStringReselector, eventReadOnlyReselector, eventStatusReselector } from '../../store/reselectors/events.reselector';
import { PaymentGridData, BudgetSectionGridData } from '../../helpers/grid-helpers';
import { revenuePaymentsReselector, sectionsReselector, linkableCostSectionsReselector, linkableSectionHasChangesMapReselector } from '../../store/reselectors/budget.reselector';
import { Dictionary } from '@ngrx/entity';
import { deleteIndexItemFromList, moveIndexItemDownInList, moveIndexItemUpInList } from '../../helpers/helpers';
import { ButtonListData, ButtonListDialogComponent } from '../../components/dialogues-general/buttonList.dialog.component';
import { applyItemTemplateToLineItemInPlace, convertLinkedCostSectionToRevenueSection, multiplyRevenueBudgetInPlace } from './../../helpers/budget-helpers';
import { UpdatesAvailableData, UpdatesAvailableDialogComponent } from './updates-available-dialog.component';
import { manageBudgetLinkDropdownOptions } from './../../store/reselectors/budget.data';
import { LineItemsDialogComponent, LineItemsDialogData } from './line-items.dialog.component';
import { ShareRevenueSettingsComponent, ShareRevenueSettingsDialogData } from './share-revenue-settings.component';
import { BudgetSnapshotDialogData } from './costs-view-dialog.component';
import { ManageRevenueShareDialogComponent } from './manage-revenue-share.component';
import { hideTipSelector } from '../../store/reselectors/user.reselector';
import { exportBudgetSections } from '../performers/performerSharedFunctions';
import { JoiAccount, LineItemTemplate } from 'globals/store/accounts.data';
import { EventStatus, SnapshotInfo } from 'globals/store/events.data';
import { createId, jsonCopyObject } from 'globals/helpers/helpers';
import { unlinkSectionInPlace } from 'globals/helpers/budget.helper';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { TopMenuComponent } from '../program/top.menu';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { EventStatusComponent } from 'src/app/components/events/event-status.component';
import { ActionButtonComponent } from 'src/app/components/nav-bar/action-button.component';
import { CommonModule } from '@angular/common';
import { BudgetTotalsStripComponent } from './budget-totals-strip.component';
import { BudgetSectionComponent } from './budget-section.component';
import { MatButtonModule } from '@angular/material/button';
import { ExpandingWrapperComponent } from 'src/app/components/wrappers/expanding-wrapper.component';
import { FileHandlerComponent } from 'src/app/components/file-handler/file-handler.component';
import { BudgetScheduleComponent } from './budget-schedule.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { traceNames } from 'src/app/services/performance.tracking.data';

@Component({
    selector: 'budget-revenue',
    templateUrl: './revenue.html',
    styleUrls: ['../../page.scss', './revenue.scss', '../../components/timeline/snapshot.scss'],
    styles: [`
  .snapshot { margin-left: 10px; cursor: pointer; }
  
  `],
    standalone: true,
    imports: [LoaderPaneFragmentComponent, TopMenuComponent, TipTextComponent, EventStatusComponent, ActionButtonComponent, CommonModule, BudgetTotalsStripComponent, TipTextComponent, BudgetSectionComponent, MatButtonModule, ExpandingWrapperComponent, FileHandlerComponent, BudgetScheduleComponent, MatMenuModule, MatProgressSpinnerModule],
})
export class BudgetRevenueComponent extends Wrapper<BudgetRevenueComponent> implements OnInit {
  budget: Budget
  event: JoiEvent
  account: Partial<JoiAccount>
  eventStatus: EventStatus
  readOnly = false
  closed = true
  traceNames = traceNames;

  savingSnapshot = false
  scheduleGridData: PaymentGridData[] = []
  revenueGridDatas: Dictionary<BudgetSectionGridData[]> = {}
  linkableCostSections: BudgetSection[]
  linkedChangedSectionsMap: Dictionary<BudgetSection> = {}
  manageBudgetLinkDropdownOptions = manageBudgetLinkDropdownOptions
  revenueTip = "The revenue tab is used to show the amounts you are being paid such as ticket sales, sponsors contributions, client payments etc. Or you can simply enter the budget amount you have for the event. Go to the summary tab to see the difference between revenue and costs"
  hideTip = true
  eventDateString = ''

  ngOnInit() {
    this.selectProp(hideTipSelector, 'revenue', 'hideTip')
    this.subProp(this.store.select('budget', 'budget'), 'budget')
    this.subProp(this.store.select('accounts', 'account'), 'account')
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select(eventStatusReselector), 'eventStatus')
    this.subProp(this.store.select(revenuePaymentsReselector), 'scheduleGridData')
    this.subProp(this.store.select(sectionsReselector), 'revenueGridDatas')
    this.subProp(this.store.select(linkableCostSectionsReselector), 'linkableCostSections')
    this.subProp(this.store.select(linkableSectionHasChangesMapReselector), 'linkedChangedSectionsMap')
    this.selectProp(eventReadOnlyReselector, null, 'closed')
    this.selectProp(eventDateStringReselector, null, 'eventDateString')
  }

  changeCurrency(currency: string) {
    this.budget.currency = currency
    this.userService.updateSettings({ budgetCurrency: currency })
    this.saveBudget()
  }

  export() {
    exportBudgetSections(this.budget, this.budget.revenueIds, 'revenue', this.dialog)
  }


  async viewUpdates(section: BudgetSection, updatedSection: BudgetSection) {
    const data: UpdatesAvailableData = {
      previousSection: convertLinkedCostSectionToRevenueSection(section.linkedCache, this.budget.currency),
      updatedSection: convertLinkedCostSectionToRevenueSection(updatedSection, this.budget.currency),
      budget: this.budget,
      isRevenue: true
    }
    const update = await openDialogGetResult(this.dialog, UpdatesAvailableDialogComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
    if (update) {

      const newSection = data.updatedSection

      newSection.linkId = updatedSection.id
      newSection.id = section.id

      delete newSection.isQuote
      newSection.linkedCache = jsonCopyObject(updatedSection)

      this.budget.sections[section.id] = newSection
      this.saveBudget()
    }
  }

  async addItem({ event, row }: AddItemRowData<BudgetSectionGridData>, revenueId: string) {
    console.log("Should be adding item...", { event, row })
    const data: LineItemsDialogData = {
      x: event.x - 100,
      y: event.y + 27
    }
    const item = await openDialogGetResult<LineItemTemplate>(this.dialog, LineItemsDialogComponent, {
      width: '200px',
      autoFocus: false,
      data,
      disableClose: true
    })

    if (item) {
      applyItemTemplateToLineItemInPlace(this.budget.currency, this.budget.sections[revenueId], row.id, item, false)
      this.saveBudget()
    }

  }

  async manageLink(index: number, id: string, command: ManageBudgetLinkOption) {
    const section = this.budget.sections[id]
    switch (command) {
      case 'remove':
        this.deleteSection(index, id)
        break
      case 'unlink':
        unlinkSectionInPlace(section)
        this.saveBudget()
        break
    }
  }

  saveBudget() {
    this.budgetService.updateBudget(this.event.eventId, this.budget)
  }

  markDeletedLinkSection(id: string) {
    this.budget.sections[id].linkJustDeleted = false
    this.saveBudget()
  }

  saveSection(section: BudgetSection) {
    this.budget.sections[section.id] = section
    this.saveBudget()
  }

  saveSectionSettingDefaults(settings: Partial<SectionSettings>) {
    this.accountService.checkAndUpdateBudgetSectionSettingsDefaults(settings)
  }

  deleteSection(index: number, id: string) {
    this.budget.revenueIds = deleteIndexItemFromList(index, this.budget.revenueIds)
    delete this.budget.sections[id]
    this.saveBudget()
  }

  savePaymentSchedule(schedule: BudgetSchedule) {
    this.budget.revenuePaymentSchedule = schedule
    this.saveBudget()
  }

  hideRevenueTip() {
    this.settingsService.hideTipType('revenue')
  }

  saveFiles(files) {
    this.budget.revenueFiles = files
    this.saveBudget()
  }

  addSection() {
    const newSection = createEmptySection(this.account)
    this.budget.revenueIds.push(newSection.id)
    this.budget.sections[newSection.id] = newSection
    this.saveBudget()
  }

  moveUp(i: number) {
    this.budget.revenueIds = moveIndexItemUpInList(i, this.budget.revenueIds)
    this.saveBudget()
  }

  moveDown(i: number) {
    this.budget.revenueIds = moveIndexItemDownInList(i, this.budget.revenueIds)
    this.saveBudget()
  }

  
  async linkCostSection(event) {
    const data: ButtonListData<BudgetSection> = {
      x: event.x - 125,
      y: event.y + 27,
      title: 'Cost Sections',
      choiceObjects: this.linkableCostSections,
      choiceKey: 'name',
      selected: null,
      selectedKey: 'id',
      successLabel: 'Add',
    }
    const { selected, cancelled, submitted } = await openDialogGetResult<{ selected: string, cancelled: boolean, submitted: boolean }>(this.dialog, ButtonListDialogComponent, {
      width: '300px',
      autoFocus: false,
      data,
      backdropClass: 'clear',
    })
    console.log({ data })
    if (!selected || (!submitted && !cancelled)) return

    const oldSection = this.budget.sections[selected as string]
    const newSection = convertLinkedCostSectionToRevenueSection(oldSection, this.budget.currency)
    newSection.linkId = newSection.id
    delete newSection.isQuote
    newSection.id = createId()
    newSection.linkedCache = jsonCopyObject(oldSection)

    this.budget.revenueIds.push(newSection.id)
    this.budget.sections[newSection.id] = newSection
    this.saveBudget()

  }

  async openSnapshot(info: SnapshotInfo) {
    const data: BudgetSnapshotDialogData = { info, eventId: this.event.eventId }
    await openDialogGetResult(this.dialog, ManageRevenueShareDialogComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
  }

  async share(event: MouseEvent) {
    const data: ShareRevenueSettingsDialogData = {
      x: event.x - 350,
      y: event.y + 27,
      conversionRate: 1,
      version: this.budget.version,
      detailedView: true,
      budgetCurrency: this.budget.currency,
      account: this.account
    }
    const settings = await openDialogGetResult<ShareRevenueSettingsDialogData>(this.dialog, ShareRevenueSettingsComponent, {
      width: '400px',
      autoFocus: false,
      data,
      backdropClass: 'clear',
    })
    console.log({ settings })
    if (!settings) return

    const info: SnapshotInfo = {
      id: await this.shareService.generateShareCode(),
      name: `Version ${this.budget.version}`,
      timestamp: new Date().getTime(),
      active: true
    }
    
    const { hidePaymentSchedule, hideFileLinks, detailedView, showInAnotherCurrency, conversionRate, headerDesktopUrl, headerMobileUrl, footerText, currencyId} = settings
    const budget = jsonCopyObject(this.budget)
    if (showInAnotherCurrency && currencyId !== this.budget.currency && conversionRate && conversionRate !== 1) {
      multiplyRevenueBudgetInPlace(budget, conversionRate)
    }
    budget.currency = currencyId

    const { totalRevenue, revenueDiscount, revenueFees, revenueSubtotal, revenueTax, version, revenueIds, currency, sections: oldSections } = budget

    const sections: Dictionary<BudgetSection> = {}
    revenueIds.forEach(id => {
      const section = jsonCopyObject(oldSections[id])
      console.log({ lineItems: section.lineItems })
      if (!detailedView) delete section.lineItems
      else section.lineItems = section.lineItems.filter(li => li.item || li.description || li.quantity || li.unitCost)
      sections[id] = section
    })

    const revenueBudgetSnapshot: BudgetRevenueShare = {
      revenueIds, sections, version, currency,
      totalRevenue: totalRevenue || null,
      revenueDiscount: revenueDiscount || null,
      revenueFees: revenueFees || null,
      revenueSubtotal: revenueSubtotal || null,
      revenueTax: revenueTax || null,
      headerDesktopUrl: headerDesktopUrl || null, 
      headerMobileUrl: headerMobileUrl || null, 
      footerText: footerText || null,
      eventName: this.event.title,
      dateString: this.eventDateString || null
    }

    if (!hidePaymentSchedule) revenueBudgetSnapshot.revenuePaymentSchedule = budget.revenuePaymentSchedule
    console.log({ revenueBudgetSnapshot })

    if (!hideFileLinks) revenueBudgetSnapshot.revenueFiles = budget.revenueFiles

    await this.eventService.uploadBudgetSnapshot(info, revenueBudgetSnapshot)
    
    this.budget.version = this.budget.version + 1
    this.budget.revenueSnapshots.push(info)
    await this.budgetService.updateBudget(this.event.eventId, this.budget)
    
    this.openSnapshot(info)
  }

}